module.exports = __webpack_public_path__ + "img/text.624c8a42.webp";